/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_TRACKER = gql`
query GetTracker($getTrackerId: String!) {
  getTracker(id: $getTrackerId) {
    logs {
      email
      job_error
      job_parameters
      job_result
      tracker_id
      txn_id
    }
  }
}
`;
